import React, { useState, useEffect } from "react";
import { UrduInput } from "../../../Components/Shared/UrduInput";

function PricingModal({ isOpen, onClose, onSubmit, editData, titlePrefix = "" }) {
  const [plotSize, setPlotSize] = useState("");
  const [plotSize_ur, setPlotSizeUr] = useState("");
  const [layout, setLayout] = useState("");
  const [structure, setStructure] = useState("");
  const [interiorDesign, setInteriorDesign] = useState("");
  const [boQs, setBoQs] = useState("");
  const [status, setStatus] = useState(true);

  useEffect(() => {
    if (editData) {
      setPlotSize(editData.plotSize || "");
      setPlotSizeUr(editData.plotSize_ur || "");
      setLayout(editData.layout || "");
      setStructure(editData.structure || "");
      setInteriorDesign(editData.interiorDesign || "");
      setBoQs(editData.boQs || "");
      setStatus(editData.status !== undefined ? editData.status : true);
    } else {
      setPlotSize("");
      setPlotSizeUr("");
      setLayout("");
      setStructure("");
      setInteriorDesign("");
      setBoQs("");
      setStatus(true);
    }
  }, [editData]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const pricingData = {
      plotSize,
      plotSize_ur,
      layout,
      structure,
      interiorDesign,
      boQs,
      status,
      ...(editData && editData.id ? { id: editData.id } : {}),
    };
    onSubmit(pricingData);
    setPlotSize("");
    setPlotSizeUr("");
    setLayout("");
    setStructure("");
    setInteriorDesign("");
    setBoQs("");
    setStatus(true);
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white w-11/12 max-w-lg p-6 rounded shadow-lg">
        <h3 className="text-xl font-bold mb-4">
          {editData ? `Edit ${titlePrefix}Pricing` : `Add ${titlePrefix}Pricing`}
        </h3>
        <form onSubmit={handleSubmit}>
          {/* Plot Size */}
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              Plot Size
            </label>
            <input
              type="text"
              value={plotSize}
              onChange={(e) => setPlotSize(e.target.value)}
              placeholder="Enter Plot Size"
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
            <UrduInput
              label="پلاٹ کا سائز"
              name="plotSize_ur"
              value={plotSize_ur}
              onChange={(e) => setPlotSizeUr(e.target.value)}
            />
          </div>
          {/* Layout */}
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              Layout
            </label>
            <input
              type="text"
              value={layout}
              onChange={(e) => setLayout(e.target.value)}
              placeholder="Enter Layout Price"
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>
          {/* Structure */}
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              Structure
            </label>
            <input
              type="text"
              value={structure}
              onChange={(e) => setStructure(e.target.value)}
              placeholder="Enter Structure Price"
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>
          {/* Interior Design */}
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              Interior Design
            </label>
            <input
              type="text"
              value={interiorDesign}
              onChange={(e) => setInteriorDesign(e.target.value)}
              placeholder="Enter Interior Price"
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>
          {/* BoQs */}
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold mb-2">
              BoQs
            </label>
            <input
              type="text"
              value={boQs}
              onChange={(e) => setBoQs(e.target.value)}
              placeholder="Enter BoQs Price"
              className="w-full px-4 py-2 border rounded-lg"
              required
            />
          </div>
          {/* Buttons */}
          <div className="flex justify-end gap-3">
            <button
              type="button"
              className="btn btn-reset-filter justify-center"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn justify-center ${
                editData ? "btn-edit text-white" : "btn-primary"
              }`}
            >
              {editData ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PricingModal;
